import {InjectionToken} from '@angular/core';

export const CONFIGURATION_TOKEN = new InjectionToken<string>('configuration_token');
